var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-view"},[(_vm.component)?_c(_vm.component,{ref:"dynamicComponent",tag:"component",staticClass:"widget-view__content"}):_c('div',{staticClass:"widget-view__loading"},[_c('p',[_vm._v("Loading...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }